import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
  Linking,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import DatePicker from "../../component/datepicker";
import TenUser from "./tenuser";
import Twentyoneuser from "./twenty-oneuser";
import TwentyOneUserDetail from "./twenty-oneuser-detail";
import Modal from "modal-react-native-web";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";

const { width, height } = Dimensions.get("window");

export default function userevent({ navigation, route }) {
  const item = route.params;
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(0);
  const focus = useIsFocused();
  const [data, setData] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const [currentDate, setCurrentDate] = useState(null); // Default to today's date in DD/MM/YYYY forma
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [currentName, setCurrentName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [total, setTotal] = useState(0);
  const [itemsPerPage] = useState(10);
  const [email, setEmail] = useState("");

  const handleSelectDate = () => {
    setShowDatePicker(true);
  };

  const handleDateSelected = (date) => {
    const formattedDate = date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
    setCurrentDate(formattedDate);
    setCurrentPage(1); // Reset to first page when date changes
    setShowDatePicker(false);
  };

  const handleNameChange = (name) => {
    setCurrentName(name);
    setCurrentPage(1); // Reset to first page when search changes
  };

  const handleEmailChange = (currentEmail) => {
    setEmail(currentEmail);
    setCurrentPage(1); // Reset to first page when search changes
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const renderPaginationControls = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust start page if we're near the end
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Previous button
    pages.push(
      <TouchableOpacity
        key="prev"
        onPress={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={[styles.paginationButton, currentPage === 1 && styles.disabledButton]}
      >
        <Text style={[styles.paginationText, currentPage === 1 && styles.disabledText]}>←</Text>
      </TouchableOpacity>
    );

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <TouchableOpacity
          key={i}
          onPress={() => handlePageChange(i)}
          style={[styles.paginationButton, i === currentPage && styles.activePage]}
        >
          <Text style={[styles.paginationText, i === currentPage && styles.activePageText]}>{i}</Text>
        </TouchableOpacity>
      );
    }

    // Next button
    pages.push(
      <TouchableOpacity
        key="next"
        onPress={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={[styles.paginationButton, currentPage === totalPages && styles.disabledButton]}
      >
        <Text style={[styles.paginationText, currentPage === totalPages && styles.disabledText]}>→</Text>
      </TouchableOpacity>
    );

    return (
      <View style={styles.paginationContainer}>
        <Text style={styles.paginationInfo}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} - {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} items
        </Text>
        <View style={styles.paginationControls}>
          {pages}
        </View>
      </View>
    );
  };

  async function getEvent(page = 1) {
    let query = {
      page: page,
      limit: itemsPerPage
    }

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        name: currentName,
      }
    }

    if (email && email.trim() !== "") {
      query = {
        ...query,
        email: email,
      }
    }

    apiservice({
      path: "/event/validateLogData?event_id=82",
      method: "get",
      token: token?.accessToken,
    })

    const response = await apiservice({
      path: "/event/getrankingByEvent_id/" + item.id + "?" + new URLSearchParams(query).toString(),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setData(response.data.data);
      setTotalItems(response.data?.pagination?.totalItems || 0);
      setTotalPages(response.data?.pagination?.totalPages || 0);
      setTotal(response.data?.pagination?.totalItems || 0);
    }
  }

  async function handleOrderBy(orderBy) {
    let query = {
      page: currentPage,
      limit: itemsPerPage,
      orderBy: orderBy,
    }

    if (orderBy !== null) {
      query = {
        ...query,
        orderBy: orderBy
      }
    }

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        name: currentName,
      }
    }

    if (email && email.trim() !== "") {
      query = {
        ...query,
        email: email,
      }
    }

    apiservice({
      path: "/event/validateLogData?event_id=82",
      method: "get",
      token: token?.accessToken,
    })

    const response = await apiservice({
      path: "/event/getrankingByEvent_id/" + item.id + "?" + new URLSearchParams(query).toString(),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setData(response.data.data);
      setTotalItems(response.data?.pagination?.totalItems || 0);
      setTotalPages(response.data?.pagination?.totalPages || 0);
      setTotal(response.data?.pagination?.totalItems || 0);
    }
  }

  async function getEventById(id, currentPage = 1) {
    if (!id) return;

    let query = {
      page: currentPage,
      limit: itemsPerPage
    }

    if (currentPage) {
      query = {
        ...query,
        page: currentPage
      }
    }

    if (currentDate) {
      query = {
        ...query,
        date: currentDate.split('/').reverse().join('-') // Convert to YYYY-MM-DD format
      }
    }

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        profileName: currentName
      }
    }

    if (email && email.trim() !== "") {
      query = {
        ...query,
        email: email
      }
    }

    const response = await apiservice({
      path: "/event/allLocationByEvent/" + id + "?" + new URLSearchParams(query).toString(),
      method: "get",
      token: token?.accessToken,
    });

    if (response.status == 200) {
      setDetailData(response.data.data);
      setTotalItems(response.data?.pagination
        ?.totalItems || 0);
      setTotalPages(response.data?.pagination?.totalPages || 0);
    }
  }

  async function exportGetEventById(id) {
    if (!id) return;

    let query = {}

    if (currentDate) {
      query = {
        date: currentDate.split('/').reverse().join('-') // Convert to YYYY-MM-DD format
      }
    }

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        profileName: currentName
      }
    }

    Linking.openURL("https://api-sosorun.asiaconnectth.com/api/event/generateExcelAllLocationByEvent/" + id + "?page=1&limit=1000&" + new URLSearchParams(query).toString(),)
  }

  async function exportGetAllUserEventById(id) {
    if (!id) return;

    let query = {}

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        name: currentName
      }
    }

    if (email && email.trim() !== "") {
      query = {
        ...query,
        email: email
      }
    }

    Linking.openURL("https://api-sosorun.asiaconnectth.com/api/event/exportGetAllUserEventById/" + id + "?" + new URLSearchParams(query).toString(),)
  }

  async function exportGetEventByIdWithTotal(id) {
    if (!id) return;

    let query = {
      withTotal: true, // Include total distance and duration
    }

    if (currentDate) {
      query = {
        ...query,
        date: currentDate.split('/').reverse().join('-') // Convert to YYYY-MM-DD format
      }
    }

    if (currentName && currentName.trim() !== "") {
      query = {
        ...query,
        profileName: currentName
      }
    }

    Linking.openURL("https://api-sosorun.asiaconnectth.com/api/event/generateExcelAllLocationByEvent/" + id + "?page=1&limit=1000&" + new URLSearchParams(query).toString(),)
  }


  useEffect(() => {
    if (page === 0) {
      getEvent(currentPage);
    } else {
      getEventById(item.id, currentPage);
    }
  }, [currentPage, page]);

  useEffect(() => {
    getEvent();
  }, [focus]);

  useEffect(() => {
    if (page === 0) {
      getEvent(currentPage);
    }
    if (page === 1 || page === 3) {
      getEventById(item.id, currentPage);
    }
  }, [page, currentDate, currentName, focus, email]);

  return (
    <View style={styles.container}>
      <DatePicker
        visible={showDatePicker}
        onClose={() => setShowDatePicker(false)}
        onSelectDate={handleDateSelected}
        currentDate={currentDate ? new Date(currentDate.split('/').reverse().join('-')) : new Date()}
      />
      <Modal
        animationType="slide"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModal(!modal);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={styles.textdel}>
              ค้นหาเลข ID เพื่อทำการ ADD เข้าสู่รายการ
            </Text>
            <View style={{ flexDirection: "row" }}>
              <Text style={styles.textdel}>Vip</Text>
              <TextInput placeholder="1234456" style={styles.inputmodal} />
            </View>
            <View
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignSelf: "flex-end",
              }}
            >
              <TouchableOpacity style={styles.touchadd1}>
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => setModal(!modal)}
                style={[styles.touchadd1, { marginHorizontal: 25 }]}
              >
                <Text style={styles.textadd}>ยืนยัน</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>USER</Text>
            <TouchableOpacity
              onPress={() => setModal(true)}
              style={[styles.touch, { backgroundColor: "#fff" }]}
            >
              <Text style={styles.textadd}>ADD VIP</Text>
              {/* //postjoinEvent */}
            </TouchableOpacity>
          </View>
          <View style={[styles.viewfree]}>
            <View style={[styles.viewfree, { width: width * 0.4, gap: 16, justifyContent: "flex-start" }]}>
              <TouchableOpacity
                onPress={() => { setPage(0); setCurrentName(""); setCurrentPage(1); }}
                style={[
                  styles.touch,
                  { backgroundColor: page == 0 ? "#FCC81D" : "#fff" },
                ]}
              >
                <Text style={styles.textadd}>Account ({total})</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => { setPage(1); setCurrentName(""); setCurrentPage(1); }}
                style={[
                  styles.touch,
                  { backgroundColor: page == 1 ? "#FCC81D" : "#fff" },
                ]}
              >
                <Text style={styles.textadd}>Report</Text>
              </TouchableOpacity>
              <View />
            </View>
            <View />
          </View>

          {
            <View style={[styles.viewfree, { marginTop: 10 }]}>
              <View style={[styles.viewfree, { width: width * 0.4, gap: 16, justifyContent: "flex-start" }]}>
                {(page == 1 || page == 3) && <TouchableOpacity
                  onPress={() => handleSelectDate()}
                  style={[
                    styles.touch,
                    { backgroundColor: "#fff" },
                  ]}
                >
                  <Text style={styles.textadd}>{currentDate ?? "select date"}</Text>
                </TouchableOpacity>}
                {(page == 1 || page == 3) && <TouchableOpacity
                  onPress={() => {
                    setCurrentDate(null);
                    setCurrentPage(1);
                  }}
                  style={[
                    styles.touch,
                    {
                      backgroundColor: "#000",
                      width: 40,
                      height: 40,
                    },
                  ]}
                >
                  <Text style={[styles.textadd, { color: '#fff' }]}>x</Text>
                </TouchableOpacity>}

                <TextInput
                  placeholder="Search by name..."
                  value={currentName}
                  onChangeText={handleNameChange}
                  style={styles.searchInput}
                />

                {(page == 1) && <TextInput
                  placeholder="Search by email..."
                  value={email}
                  onChangeText={handleEmailChange}
                  style={styles.searchInput}
                />}

                <TouchableOpacity
                  onPress={() => {
                    setCurrentName("");
                    setCurrentPage(1);
                  }}
                  style={[
                    styles.touch,
                    { backgroundColor: "#000" },
                  ]}
                >
                  <Text style={[styles.textadd, { color: '#fff' }]}>Clear</Text>
                </TouchableOpacity>
              </View>
              {page != 0 && <TouchableOpacity
                onPress={() => page === 3 ? exportGetEventByIdWithTotal(item.id) : exportGetEventById(item.id)}
                style={[
                  styles.touch,
                  { backgroundColor: "#fff" },
                ]}
              >
                <Text style={styles.textadd}>Export</Text>
              </TouchableOpacity>}

              {page == 0 && <TouchableOpacity
                onPress={() => exportGetAllUserEventById(item.id)}
                style={[
                  styles.touch,
                  { backgroundColor: "#fff" },
                ]}
              >
                <Text style={styles.textadd}>Export</Text>
              </TouchableOpacity>}
            </View>
          }

          {page == 0 && <TenUser
            onOrderPress={handleOrderBy}
            data={data.map((item, index) => ({
              ...item,
              runningNumber: ((currentPage - 1) * itemsPerPage) + index + 1
            }))}
            price={item.price} setCurrentName={(name) => {
              setPage(3);
              setCurrentName(name);
              setCurrentPage(1);
            }} />}
          {page == 1 && (
            <View>
              <Twentyoneuser
                onOrderPress={handleOrderBy}
                data={detailData.map((item, index) => ({
                  ...item,
                  runningNumber: ((currentPage - 1) * itemsPerPage) + index + 1
                }))}
                price={item.price} setCurrentName={(name) => {
                  setPage(1);
                  setCurrentName(name);
                  setCurrentPage(1);
                }} />
            </View>
          )}
          {page == 3 && (
            <View>
              <TwentyOneUserDetail data={detailData.map((item, index) => ({
                ...item,
                runningNumber: ((currentPage - 1) * itemsPerPage) + index + 1
              }))} price={item.price} setCurrentName={(name) => {
                setPage(1);
                setCurrentName(name);
                setCurrentPage(1);
              }} />
            </View>
          )}

          {renderPaginationControls()}
        </View>
      </ScrollView >
    </View >
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.845,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.825,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
  },
  touch: {
    width: 150,
    height: 40,
    justifyContent: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#8898AA",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.65,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 30,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
  },
  inputmodal: {
    width: width * 0.53,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
    marginLeft: 20,
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  searchInput: {
    width: 200,
    height: 40,
    borderWidth: 1,
    borderColor: "#8898AA",
    borderRadius: 5,
    paddingHorizontal: 10,
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    backgroundColor: "#fff",
  },
  paginationContainer: {
    marginTop: 20,
    alignItems: "center",
    paddingVertical: 20,
  },
  paginationInfo: {
    fontSize: 14,
    fontFamily: "Prompt-Regular",
    color: "#8898AA",
    marginBottom: 10,
  },
  paginationControls: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  paginationButton: {
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "#8898AA",
    backgroundColor: "#fff",
  },
  paginationText: {
    fontSize: 16,
    fontFamily: "Prompt-Regular",
    color: "#172B4D",
  },
  activePage: {
    backgroundColor: "#FCC81D",
    borderColor: "#FCC81D",
  },
  activePageText: {
    color: "#fff",
    fontWeight: "bold",
  },
  disabledButton: {
    backgroundColor: "#F1F3F9",
    borderColor: "#E1E5E9",
  },
  disabledText: {
    color: "#8898AA",
  },
});
